import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './AdminTable.css';

// 관리자 화면 공용 표. getRowLink가 있으면 행을 눌러(또는 Enter) 상세 화면으로 이동한다.
// 이동할 때 행 데이터를 location.state.row로 넘긴다(상세 API에 없는 목록 정보를 쓰는 화면용).
export default function AdminTable({ columns, rows, rowKey, getRowLink }) {
    const navigate = useNavigate();
    if (rows.length === 0) return <p className="admin-table-empty">표시할 데이터가 없습니다.</p>;

    // 행 클릭·Enter 시 상세 경로로 이동한다.
    const rowProps = row => {
        if (!getRowLink) return {};
        const open = () => navigate(getRowLink(row), { state: { row } });
        return { className: 'clickable', tabIndex: 0, role: 'link', onClick: open, onKeyDown: e => { if (e.key === 'Enter') open(); } };
    };

    return (
        <div className="admin-table-wrap">
            <table className="admin-table">
                <thead>
                    <tr>{columns.map(column => <th key={column.key} scope="col">{column.label}</th>)}</tr>
                </thead>
                <tbody>
                    {rows.map(row => (
                        <tr key={row[rowKey]} {...rowProps(row)}>
                            {columns.map(column => <td key={column.key} className={column.className}>{column.render ? column.render(row) : row[column.key]}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

AdminTable.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        render: PropTypes.func,
        className: PropTypes.string,
    })).isRequired,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    rowKey: PropTypes.string.isRequired,
    getRowLink: PropTypes.func,
};
